<template>
  <div
    class="container-base"
    :class="bodyClass"
  >
    <v-top-navbar
      v-if="!hideNavigation"
    />

    <div class="d-flex">
      <div
        class="content w-100"
        :class="contentClass"
      >
        <v-breadcrumbs
          v-if="breadcrumbs"
          :breadcrumbs="breadcrumbs"
        />
        <router-view
          :key="$route.fullPath"
        />
      </div>
    </div>

    <v-footer
      v-if="!hideFooter"
    />

    <transition name="fade">
      <v-global-error v-if="globalError"/>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumbs from '@/common/components/Breadcrumbs.vue';
import Footer from '@/common/components/Footer.vue';
import GlobalError from '@/common/components/GlobalError.vue';
import TopNavbar from '@/reviewer/components/TopNavbar.vue';

export default {
  name: 'App',
  components: {
    'v-breadcrumbs': Breadcrumbs,
    'v-footer': Footer,
    'v-global-error': GlobalError,
    'v-top-navbar': TopNavbar,
  },
  data() {
    return {
      appConfig: {
        showSideNav: false,
      },
    };
  },
  computed: {
    ...mapGetters([
      'globalError',
      'user',
      'org',
      'breadcrumbs',
    ]),
    hideNavigation() {
      return this.$route.meta.hideNavigation;
    },
    contentClass() {
      return [
        this.$route.meta.noPadding ? '' : 'nav-padding',
        this.appConfig.showSideNav ? 'nav-open' : '',
        this.$route.meta.noPadding ? '' : 'container-lg',
      ];
    },
    hideFooter() {
      return this.$route.meta.hideFooter;
    },
    bodyClass() {
      return [
        this.$route.meta.bgClass || 'bg-default',
        this.hideFooter ? '' : 'footer-padding',
      ];
    },
    theme() {
      return this.$route.meta.theme;
    },
  },
};
</script>


<style scoped>
@import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
@import '../../../node_modules/@fortawesome/fontawesome-free/css/all.css';
@import '../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
@import "../../../node_modules/element-ui/packages/theme-chalk/lib/tooltip.css";
@import "../../common/assets/css/bootstrap-material.css";
@import "../../common/assets/css/theme-vibrant-material.css";
@import "../../common/assets/css/appwork.css";
@import "../../common/assets/css/appwork-material.css";
@import "../../common/assets/css/smartwizard.css";
@import "../../common/assets/css/theme-corporate-material.css";
@import "../../common/assets/css/style.css";

.container-base {
  min-height: 100vh;
  background-color: transparent;
  background-position: center center;
  background-size: cover;
  background-attachment: fixed;
  display: flex;
  flex-direction: column;
}

.left-nav-wrapper {
  padding-top: 85px;
  z-index: 100;
  height: 100vh;
}

.left-nav-open {
  width: 250px;
}

.footer-padding {
  padding-bottom: 120px;
}

@media (max-width: 991px) {
  .left-nav-open {
    width: 0;
  }
}

.bg-default {
  background-image: linear-gradient(rgba(255, 255, 255, 0.80), rgba(255, 255, 255, 0.925)),
  url('../../common/assets/img/bg.jpg');
}

.bg-default-dark {
  background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
  url('../../common/assets/img/bg.jpg');
}

.bg-phone {
  background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),
  url('../../common/assets/img/bg_phone.jpg');
}
</style>
